import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFilteredEvents } from '../actions';

class EventsListView extends Component {
	vanillaHasClass( elem, checkClass ) {
		//@todo: move to global js file
		return (' ' + elem.className + ' '
		       ).indexOf( ' ' + checkClass + ' ' ) > -1;
	}

	getTagList( tags ) {
		if ( 'undefined' !== typeof tags && tags.length ) {
			return 'Tags:' + tags;
		}

		return '';
	}

	renderEvents() {
		function renderRegistrationLink( event ) {
			if ( event.registration === true ) {
				return (
					<a href={ event.registration_url } className="btn btn-default btn-event" data-imiscode={event.imis_code}>
						Register Now
						<span className="sr-only"> for { event.title }</span>
					</a>
				);
			}

			return null;
		}

		function renderEntryMeta( event ) {
			if ( event.city_link ) {
				return (
					<p className="entry-meta">
						{ ! event.is_hybrid ? (
							<a href={event.city_link}>{event.city.name}</a>
						) : (
							<a href={event.city_link}>{event.city.name}/Online</a>
						)}
						| <span className="published-date"> {event.formatted_date}</span>
					</p>
				);
			} else {
				return (
					<p className="entry-meta">
						<span className="published-date">{ event.formatted_date }</span>
					</p>
				);
			}
		}

		function renderEventContent( event ) {
			if ( event.excerpt && !event.subtitle ) {
				return (
					<div className="entry-content">
						<p>{ event.excerpt }</p>
						<a className="read-more" href={ event.link } data-imiscode={event.imis_code} >
							Read more&nbsp;
							<span className="sr-only">{ event.title }</span>
							<span className="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
						</a>
					</div>
				);
			} else if ( !event.excerpt && event.subtitle ) {
				return (
					<div className="entry-content">
						<p>{ event.subtitle }</p>
					</div>
				);
			} else if ( event.excerpt && event.subtitle ) {
				return (
					<div className="entry-content">
						<p>{ event.subtitle }</p>
						<p>{ event.excerpt }</p>
						<a className="read-more" href={ event.link } data-imiscode={event.imis_code}>
							Read more&nbsp;
							<span className="sr-only">{ event.title }</span>
							<span className="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
						</a>
					</div>
				);
			} else {
				return (<div className="entry-content"/>
				);
			}
		}

		let filteredEvents = getFilteredEvents( this.props.searchTerm, this.props.regionTerm, this.props.categoryTerm, this.props.events );
		let loadedState = this.vanillaHasClass( document.querySelector( '.react-fallback' ), 'loaded' );

		if ( Array.isArray( filteredEvents ) && filteredEvents.length && loadedState === true ) {
			return filteredEvents.map( ( event, ind ) => {
					return (
							<div>
								{ ! event.is_featured && event.hide_event !== true ? (
									<article className="two-col-content-panel" key={ ind }>
											<div className="col-sm-8">
												{ renderEntryMeta( event ) }
												<h3 className="entry-title">
													<a href={ event.link } data-imiscode={event.imis_code}>
														{ event.title }
													</a>
												</h3>
												{ renderEventContent( event )}

												<div className="default-tags-list" dangerouslySetInnerHTML={ { __html: this.getTagList( event.tags ) } } />
											</div>

											<div className="col-sm-4 buttons">
												<a href={ event.link } className="btn btn-default btn-event" data-imiscode={event.imis_code}>
													Event Details
													<span className="sr-only"> for { event.title }</span>
												</a>
												{ renderRegistrationLink( event ) }
											</div>
									</article>
								) : ('')}
			                </div>
					);
				} );
		} else if ( loadedState === true && filteredEvents.length === 0 ) {
			//when filters return no posts
			return (
				<p className="alert alert-info">No events found. Please clear your filters and try again.</p>
			);
		} else {
			//when posts haven't loaded yet
			return [ 0, 1, 2 ].map( ind => this.getEmptyEvent() );
		}
	}

	getEmptyEvent() {
		return (<article className="two-col-content-panel" key={ ind }>
				<div className="col-sm-8">
					{ renderEntryMeta() }
					<h3 className="entry-title">&nbsp;</h3>
					<div className="entry-content">&nbsp;</div>
				</div>

				<div className="col-sm-4 buttons">
					<a href="" className="btn btn-default btn-event">
						&nbsp;
					</a>
					<a href="" className="btn btn-default btn-event">
						&nbsp;
					</a>
				</div>
			</article>
		);
	}

	render() {
		return (<div className="events-post-list">
				{ this.renderEvents() }
			</div>
		);
	}
}

function mapStateToProps( { events, searchTerm, regionTerm, categoryTerm } ) {
	return { events, searchTerm, regionTerm, categoryTerm };
}

export default connect( mapStateToProps, null )( EventsListView );
